import { z } from 'zod'

export const addMemberSchema = z.object({
  userId: z.string().min(1, 'User ID is required'),
})

export const updateMemberRoleSchema = z.object({
  role: z.enum(['ADMIN', 'MEMBER']),
})

export const transferOwnershipSchema = z.object({
  newOwnerId: z.string().min(1, 'New owner ID is required'),
})

export const createReportSchema = z.object({
  contentType: z.enum(['REFLECTION', 'BOOK_CLUB']),
  contentId: z.string().min(1, 'Content ID is required'),
  reason: z.enum(['SPAM', 'HARASSMENT', 'INAPPROPRIATE', 'SPOILER', 'OTHER']),
  details: z.string().max(1000, 'Details must be 1000 characters or less').optional(),
})

export const reviewReportSchema = z.object({
  status: z.enum(['REVIEWED', 'DISMISSED', 'ACTIONED']),
  softDelete: z.boolean().optional(),
})

export const reportQuerySchema = z.object({
  status: z.enum(['PENDING', 'REVIEWED', 'DISMISSED', 'ACTIONED']).optional(),
  contentType: z.enum(['REFLECTION', 'BOOK_CLUB']).optional(),
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).max(50).default(20),
})

export type AddMemberInput = z.infer<typeof addMemberSchema>
export type UpdateMemberRoleInput = z.infer<typeof updateMemberRoleSchema>
export type TransferOwnershipInput = z.infer<typeof transferOwnershipSchema>
export type CreateReportInput = z.infer<typeof createReportSchema>
export type ReviewReportInput = z.infer<typeof reviewReportSchema>
export type ReportQueryInput = z.infer<typeof reportQuerySchema>
